// components/Cart/DraftItems.js
import React, { useState, useEffect } from 'react';
import styles from '../../ChatApp.module.css';

const DraftItems = ({ onParseDraft }) => {
    const [draftText, setDraftText] = useState('');
    useEffect(() => {
        const savedDraft = localStorage.getItem('orderDraft');
        if (savedDraft) setDraftText(savedDraft);
    }, []);

    const handleChange = (e) => {
        setDraftText(e.target.value);
        try {
            localStorage.setItem('orderDraft', e.target.value);
        } catch (error) {
            console.warn("Could not save draft to local storage", error);
        }
    };
    const handleCopy = () => navigator.clipboard.writeText(draftText);
    const handleParse = () => {
        if (!draftText.trim()) return;
        onParseDraft(draftText);
    };

    return (
        <div className={styles.cartContent} style={{display: 'flex', flexDirection: 'column', paddingRight: 0, marginRight: 0}}>
            <p style={{fontSize: '13px', color: 'var(--text-light)', marginTop: 0, paddingBottom: '10px', borderBottom: '1px solid var(--border-color)'}}>
                Type or paste a list here. Then, click "Parse" to add to your order. Saved automatically.
            </p>
            <textarea
                value={draftText}
                onChange={handleChange}
                placeholder="e.g.,&#10;5 kettle chips&#10;20 haribo frogs&#10;clif bar x 10"
                style={{
                    flex: 1, width: '100%', minHeight: '150px',
                    fontFamily: 'inherit', fontSize: '14px', padding: '10px',
                    border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-md)',
                    resize: 'none', marginTop: '15px'
                }}
            />
            <div style={{display: 'flex', gap: '10px', marginTop: '10px', paddingTop: '15px', borderTop: '2px solid var(--primary-color)'}}>
                <button className={styles.adminButton} style={{marginTop: 0, flex: 1, backgroundColor: 'var(--text-light)'}} onClick={handleCopy}>
                    Copy
                </button>
                <button className={styles.adminButton} style={{marginTop: 0, flex: 2}} onClick={handleParse}>
                    Parse & Add to Cart
                </button>
            </div>
        </div>
    );
};

export default DraftItems;